import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { ArticlePreview } from "sdk/articles";
import { ArticleCard } from "~/features/Library";
import { ArticleCardType } from "~/features/Library/utils";

interface Props {
  article: ArticlePreview;
  type: ArticleCardType;
}

export const ArticleWrapper: FC<Props> = ({ article, type }) => {
  return (
    <Flex key={article._id} h="100%" w="100%">
      <ArticleCard type={type} {...article} />
    </Flex>
  );
};
